import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ScheduleComponent } from './schedule.component';
import { MealPeriodModule } from '@finder/shared/components/meal-period/meal-period.module';
import { ScheduleListModule } from '@finder/shared/components/schedule-list/schedule-list.module';
import { AnchorModule } from '@finder/shared/components/anchor/anchor.module';
import { ButtonModule } from '@finder/shared/components/button/button.module';

@NgModule({
    imports: [
        CommonModule,
        MealPeriodModule,
        ScheduleListModule,
        AnchorModule,
        ButtonModule
    ],
    declarations: [
        ScheduleComponent,
    ],
    providers: [],
    exports: [
        ScheduleComponent,
    ]
})
export class ScheduleModule {}
